import fetch from '../utilities/fetchAxios'

export const getOrderActivity = async (orderId: string | number) => {
  const method = 'GET'
  const path = `/order-activity/v1/${orderId}`
  return fetch(method, path)
}
